import ts from 'typescript';
import * as file_ from './file';
export const printBundle = (programIn, files, substituteNode) => {
    const program = programIn;
    const compiler = ts;
    const host = {
        getPrependNodes: () => [],
        getCanonicalFileName: (fileName) => (ts.sys.useCaseSensitiveFileNames ? fileName : fileName.toLowerCase()),
        getCommonSourceDirectory: program.getCommonSourceDirectory,
        getCompilerOptions: program.getCompilerOptions,
        getCurrentDirectory: program.getCurrentDirectory,
        getNewLine: () => ts.sys.newLine,
        getSourceFile: program.getSourceFile,
        getSourceFileByPath: program.getSourceFileByPath,
        getSourceFiles: program.getSourceFiles,
        isSourceFileFromExternalLibrary: program.isSourceFileFromExternalLibrary,
        writeFile: ts.sys.writeFile,
        readFile: ts.sys.readFile,
        fileExists: ts.sys.fileExists,
        directoryExists: ts.sys.directoryExists,
    };
    const writer = compiler.createTextWriter(ts.sys.newLine);
    const sourceMapGenerator = compiler.createSourceMapGenerator(host, 'foo.ts', program.getCurrentDirectory(), program.getCurrentDirectory(), {});
    const printer = compiler.createPrinter({ ...program.getCompilerOptions(), outFile: 'foo.ts' }, {
        substituteNode,
    });
    printer.writeBundle(ts.createBundle(files), writer, sourceMapGenerator);
    const resolvedSourceMap = sourceMapGenerator.toJSON();
    return {
        text: writer.getText(),
        sourceMap: {
            ...resolvedSourceMap,
            sourcesContent: resolvedSourceMap.sources.map((filePath) => {
                const foundFile = files.find((file) => file_.getFilePath(file).endsWith(filePath));
                return foundFile === undefined ? '' : file_.getText(foundFile);
            }),
        },
    };
};
export const markOriginal = (node) => {
    node.__originalSet = true;
    return ts.setSourceMapRange(node, file_.createSourceMapRange(node));
};
export const setOriginal = (node, original) => {
    if (!node.__originalSet) {
        const transformedNode = ts.moveSyntheticComments(ts.setSourceMapRange(ts.setOriginalNode(node, original), file_.createSourceMapRange(original)), original);
        node.__originalSet = true;
        return transformedNode;
    }
    return node;
};
export const isOriginal = (node) => !node.__originalSet;
const context = {
    getCompilerOptions: () => ({}),
    startLexicalEnvironment: () => {
    },
    suspendLexicalEnvironment: () => {
    },
    resumeLexicalEnvironment: () => {
    },
    endLexicalEnvironment: () => undefined,
    hoistFunctionDeclaration: () => {
    },
    hoistVariableDeclaration: () => {
    },
    requestEmitHelper: () => {
    },
    readEmitHelpers: () => undefined,
    enableSubstitution: () => {
    },
    isSubstitutionEnabled: () => false,
    onSubstituteNode: (_hint, node) => node,
    enableEmitNotification: () => {
    },
    isEmitNotificationEnabled: () => false,
    onEmitNode: (hint, node, emitCallback) => {
        emitCallback(hint, node);
    },
};
export const setOriginalRecursive = (start, original) => {
    const seen = new Set();
    function visit(node) {
        if (seen.has(node)) {
            return node;
        }
        seen.add(node);
        const transformedNode = setOriginal(node, original);
        return ts.visitEachChild(transformedNode, visit, context);
    }
    return visit(start);
};

//# sourceMappingURL=print.js.map
